<template>
  <v-dialog v-model="showDeleteTestTypeModal" width="400" v-if="showDeleteTestTypeModal" persistent>
    <v-card>
      <v-card-title class="headline error white--text" primary-title
        >Delete test type
        <v-spacer></v-spacer>
        <v-btn @click="closeModal()" left text fab small color="white"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="mt-4 mb-0"> Are you sure you want delete this test type? </v-card-text>
      <v-card-text class="mt-0">
        Name: <strong>{{ clickedItem.name }}</strong> <br />
        Prefix: <strong>{{ clickedItem.prefix }}</strong> <br />
        Type: <strong>{{ clickedItem.type }}</strong> <br />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeModal()" :disabled="deleting"> Cancel </v-btn>
        <v-btn color="error" :disabled="deleting" :loading="deleting" @click="deleteTestType()" class="mx-4"> Delete </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['showDeleteTestTypeModal', 'clickedItem'],
  data() {
    return {
      deleting: false
    };
  },
  watch: {
    showDeleteTestTypeModal(n) {
      if (n == false) this.$parent.showDeleteTestTypeModal = false;
    }
  },
  created() {},
  methods: {
    closeModal() {
      this.$parent.showDeleteTestTypeModal = false;
    },
    async deleteTestType() {
      this.deleting = true;
      this.$store
        .dispatch('testTypeStore/deleteTestType', this.clickedItem.id)
        .then((data) => {
          if (data) {
            this.closeModal();
            this.$store.commit('SET_SNACKBAR', { open: true, text: 'Test type successfully deleted', color: 'success' });
          }
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }
};
</script>
